// ** Third Party Components
import styled from "styled-components";

// ** Custom Components
import Text from "components/typography/Text";

// #####################################################

export const TagStyled = styled(Text)`
	color: ${({ status, online }) => {
		if (status === 1 || online === 0) {
			switch (online) {
				case 1:
					return "#52c522";
				case 2:
					return "#52c522";
				default:
					return null;
			}
		} else {
			switch (status) {
				case 2:
					return "#f54ae0";
				case 3:
					return "var(--dz-sys-icon-background-default)";
				default:
					return null;
			}
		}
	}};
`;

// #####################################################
